import { Entitlement, FeatureProduct } from './billing-subscription';
import { BrowseSubscriptionPlanResponse } from './pricing';

export interface PlanCardConfig {
  title: string;
  subtitle: string;
  monthlyCreditRate: number;
  yearlyCreditRate: number;
  tagline?: string;
  priceDescription: string;
  features: Feature[];
  featuresDescription: string[];
  defaultCredit: number;
  options: BrowseSubscriptionPlanResponse;
  buttonText: string;
  disabled?: boolean;
}

export interface Feature {
  title: string;
  disabled?: boolean;
}

export enum PlanActionMode {
  DOWNGRADE_FREE = 'DOWNGRADE_FREE',
  DOWNGRADE_PAID = 'DOWNGRADE_PAID',
  CANCEL_DOWNGRADE = 'CANCEL_DOWNGRADE',
  UPGRADE = 'UPGRADE',
}

interface SubscriptionDialogBaseProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export interface ConfirmPlanDialogProps extends SubscriptionDialogBaseProps {}
export interface FeedbackPlanDialogProps extends SubscriptionDialogBaseProps {
  onConfirm: (comment: string) => void;
}
export interface ResultPlanDialogProps extends SubscriptionDialogBaseProps {}

export interface BrowseProductEntitlementResponse {
  features: Entitlement[];
  products: FeatureProduct[];
}
